import prefetch from "@astrojs/prefetch/client.js"; prefetch({});